// extracted by mini-css-extract-plugin
export default {"pageSectionTitle":"PageSectionTitle-module__pageSectionTitle___HqYRZ"};